function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "86",
  height: "86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M86 43c0 23.748-19.252 43-43 43S0 66.748 0 43 19.252 0 43 0s43 19.252 43 43zm-73.314 0c0 16.742 13.572 30.314 30.314 30.314S73.314 59.742 73.314 43 59.742 12.686 43 12.686 12.686 26.258 12.686 43z",
  fill: "#E8EAED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.657 43c3.503 0 6.39-2.855 5.876-6.32A43 43 0 0049.32.467C45.855-.048 43 2.84 43 6.342c0 3.503 2.87 6.276 6.296 7.004a30.313 30.313 0 0123.358 23.358c.728 3.426 3.5 6.296 7.004 6.296z",
  fill: "#6310E5"
})));